import CardChartDropDown from '@/components/common/CardChartDropDown';
import FalconCardHeader from '@/components/common/FalconCardHeader';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import Flex from '@/components/common/Flex';
import {
  breakpointsMediaQuery,
  getColor,
  percentageOfAll,
  useMediaQuery
} from '@/helpers/utils';
import { useRef } from 'react';
import * as echarts from 'echarts/core';
import { BarChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  BarChart,
  CanvasRenderer,
  LegendComponent
]);

import { Card } from 'react-bootstrap';
import _ from 'lodash';
import timeStampToDate from '@/helpers/timeStampToDate';
import chroma from 'chroma-js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppContext } from '@/Main';
import { useDispatch } from 'react-redux';
import { showDrawer } from '@/app/common/reducers/drawer';
import { useTooltipHide } from '@/hooks/useTooltipHide';


const DistributionOfKeywordsChart = ({ data }) => {
  const {
    config: { isRTL }
  } = useAppContext();
  const dispatch = useDispatch();

  const cardRef = useRef(null);
  const chartRef = useRef(null);
  const palette = chroma
    .scale([
      chroma(getColor('primary')).brighten(2),
      chroma(getColor('primary')).darken(2)
    ])
    .mode('lab')
    .colors(6);
  const series = [
    {
      name: 'بدون رتبه',
      data: data?.map(item => _.sum(item?.ranks?.slice(100, 101))),
      itemStyle: {
        color: getColor('secondary')
      }
    },
    {
      name: '#51-100',
      data: data?.map(item => _.sum(item?.ranks?.slice(50, 100))),
      itemStyle: {
        color: palette[1]
      }
    },
    {
      name: '#21-50',
      data: data?.map(item => _.sum(item?.ranks?.slice(20, 50))),
      itemStyle: {
        color: palette[2]
      }
    },
    {
      name: '#11-20',
      data: data?.map(item => _.sum(item?.ranks?.slice(10, 20))),
      itemStyle: {
        color: palette[3]
      }
    },
    {
      name: '#4-10',
      data: data?.map(item => _.sum(item?.ranks?.slice(3, 10))),
      itemStyle: {
        color: palette[4]
      }
    },
    {
      name: '#1-3',
      data: data?.map(item => _.sum(item?.ranks?.slice(0, 3))),
      itemStyle: {
        color: palette[5],
        borderRadius: [3, 3, 0, 0]
      }
    }
  ];
  return (
    <Card ref={cardRef} className="h-100">
      <FalconCardHeader
        title={
          <div>
            توزیع کلمات{' '}
            <FontAwesomeIcon
              icon={['far', 'question-circle']}
              transform="shrink-1"
              style={{
                transform: isRTL ? 'scaleX(-1)' : 'scaleX(1)',
                pointerEvents: 'all'
              }}
              className={`ms-1 text-400 cursor-pointer check-list-item`}
              id="weeklySalesTooltip"
              onClick={e => {
                e.stopPropagation();
                e.preventDefault();

                dispatch(
                  showDrawer({
                    key: 'help',
                    payload: {
                      title: 'توزیع کلمات ',
                      tooltip: '',
                      manualData: (
                        <div>
                          <h5 className="mb-3">درباره این موضوع</h5>
                          <p className="lh-lg">
                            آیا رتبه کلمات کلیدی شما بیشتر در صفحه اول هست؟ یعنی
                            رتبه ۱ الی ۱۰ گوگل؟ یا بین صفحات ۲ الی ۵ هست؟ صفحات
                            ۲ الی ۵ میشه رتبه‌های ۱۱ الی ۵۰ و … به شما کمک
                            می‌کنه تا متوجه بشید رتبه‌ کلمات کلیدی شما بیشتر در
                            کدوم صفحات از نتایج گوگل هست.
                          </p>
                          <h5 className="mb-3">چطور استفاده کنیم؟</h5>

                          <p className="lh-lg">
                            در کل این نمودار به شما یک نگاه خوب و کلی از وضعیت
                            کلمات و اینکه تراکم رتبه کلمات کلیدی من بیشتر کجای
                            گوگل هست، میده. مثلا سایت من تازه تاسیس هست و بیشتر
                            بدون رتبه هستم، باید سعی کنم کلمات بدون رتبه رو پیدا
                            کنیم و بهتره به کمک میزفا تولز کلمات مشابه اون کلمات
                            بدون رتبه رو با ابزار تحقیق کلمات پیدا کنم و یک
                            برنامه سئویی بچینم تا بتونم بدون رتبه‌ها رو در قدم
                            اول به رتبه ۵۱ الی ۱۰۰ برسونم. یا سایت من در کلمات
                            سخت رقابت می‌کنه و بیشتر صفحه دوم هستم و مدت‌ها هست
                            که رشد نمیکنم و صفحه دو موندم، در این صورت جامعه
                            آماری کلمات شما ممکنه کم باشه ولی اگر جامعه آماری
                            کلمات شما زیاد باشه عدم رشد نشون دهنده اینکه روند
                            کار شما فرسایشی شده و باید استراتژی کارت رو در سئو
                            عوض کنی. همینطور شما می‌تونید با مقایسه توزیع کلمات
                            نسبت به روزهای قبل متوجه بشید که روند کاری که در سئو
                            سایت پیش می‌بری به سمت خوب هست یا نه؟ زمانی خوب هست
                            که توزیع کلمات مثلا از ۵۱ الی ۱۰۰ کمتر بشه و به سمت
                            ۱۱ الی ۵۰ بره و برعکس این موضوع طبیعتا جالب نیست و
                            نشون دهنده افت کلی رتبه هست. البته به شرطی که شما در
                            این مقایسه کلمه کلیدی جدیدی اضافه نکرده باشی و جامعه
                            آماری یکی باشه. اگر خواستید خیلی جامع و کامل و به
                            صورت ویدیویی این بخش یاد بگیرید، وارد{' '}
                            <a
                              href="https://help.mizfa.tools/professional-analysis-mizfa-tools/"
                              target="_blank"
                              rel="noreferrer noopener"
                            >
                              این صفحه
                            </a>{' '}
                            بشید و ویدیو ۱ قسمت ۱ نگاه کنید.
                          </p>
                        </div>
                      )
                    }
                  })
                );
              }}
            />
          </div>
        }
        titleTag="h6"
        className="py-2"
        light
        endEl={<CardChartDropDown cardRef={cardRef} chartRef={chartRef} />}
      />
      <Card.Body
        as={Flex}
        direction="column"
        justifyContent="between"
        className="py-3"
      >
        <MainBarChart
          chartRef={chartRef}
          height={'10rem'}
          categories={data?.map(item => item.update_date)}
          series={series}
          data={data}
        />
      </Card.Body>
    </Card>
  );
};

export default DistributionOfKeywordsChart;

const MainBarChart = ({ height, categories, series, chartRef, data, min = 0 }) => {
  const isMdUp = useMediaQuery(breakpointsMediaQuery.md);
  useTooltipHide(chartRef);

  const chart_series = series.map(item => {
    return {
      type: 'bar',
      name: item.name,
      data: item.data,
      stack: 'one',
      itemStyle: item.itemStyle,
      showSymbol: false,
      symbol: 'circle',
      smooth: false,
      emphasis: {
        scale: true
      }
    };
  });

  /*کانفیگ های مربوط به نمودار */
  const options = {
    textStyle: {
      fontFamily: 'dana'
    },

    legend: {
      show: false
    },

    tooltip: {
      triggerOn: isMdUp ? 'mousemove' : 'click',
      trigger: 'axis',
      padding: [7, 10],
      backgroundColor: getColor('gray-100'),
      borderColor: getColor('gray-300'),
      textStyle: { color: getColor('gray-1100') },
      borderWidth: 1,
      formatter: params => {
        let tooltipItem = ``;
        const totalCount = _.sum(params.map(item => item.value));
        const currentDateIndex = categories.findIndex(cat => cat == params[0].axisValue);
        const index = currentDateIndex !== -1 ? currentDateIndex : params[0].dataIndex;
        const currentDepth = data?.[index]?.depth;

        params.reverse().forEach(el => {
          let displayName = el.seriesName;
          if (el.seriesName === 'بدون رتبه' && currentDepth) {
            displayName = `< ${currentDepth * 10}`;
          }

          tooltipItem =
            tooltipItem +
            `
              <div class="text-700 d-flex flex-column flex-md-row gap-0 align-items-start align-items-md-center justify-content-between w-100 gap-1">     
                <span class="text-800 d-flex flex-row-reverse align-items-center gap-1">${displayName?.toString()?.toPersianDigit()}${el.marker}</span>
                <span class="d-flex align-items-center gap-1">
                <span class="fw-light text-800 fs--1"> (${Number(percentageOfAll(el.value, totalCount)).toFixed(0).toString()?.toPersianDigit()}%)</span>
                <span class="fw-bold text-1000">${el?.value?.toString()?.toPersianDigit()}</span>
                </span>
                </div>`;
        });
        return `<div style="width:${isMdUp && '200px'};" class="d-flex flex-column align-items-end">
                  <p class='mb-2 text-1000 fw-bold'>
                    ${timeStampToDate(Number(params[0].axisValue))
            .slice(8)
            .toPersianDigit()}
                  </p>
                  ${tooltipItem}
                </div>`;
      },
      transitionDuration: 0,
      axisPointer: {
        type: 'none'
      }
    },
    xAxis: {
      type: 'category',
      data: categories,
      axisLine: {
        lineStyle: {
          color: getColor('gray-300'),
          type: 'solid'
        }
      },
      axisTick: { show: false },
      axisLabel: { show: false },
      splitLine: {
        show: false
      }
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        show: true,
        color: getColor('gray-800'),
        margin: 5
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: getColor('gray-200')
        }
      },
      axisTick: { show: false },
      axisLine: { show: false },
      min
    },
    series: chart_series,
    grid: { right: '3%', left: '10%', bottom: '10%', top: '5%' }
  };

  return (
    <ReactEChartsCore
      ref={chartRef}
      echarts={echarts}
      option={options}
      style={{ height }}
    />
  );
};
